import React, { useState } from "react";
import cn from "classnames";
import { Dialog as MUIDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from "@material-ui/core";

import { useDialogStyles } from "./Dialog.styles";

import type { IDialogProps } from "./Dialog.types";
import type { FC } from "react";

export const Dialog: FC<IDialogProps> = (props) => {
  const classes = useDialogStyles();
  const { open, onCancel, onApply, name, saved } = props;
  return (
    <MUIDialog
      open={open}
      classes={{ paper: classes.root }}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={classes.header}>
        Save bulk export settings
      </DialogTitle>
      {saved ? (
        <>
          <DialogContent className={classes.content}>
            <DialogContentText id="alert-dialog-description" className={classes.text}>
              The Bulk export settings successfully saved
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.buttons}>
            <Button onClick={onCancel} variant="contained" color="primary" autoFocus className={cn(classes.button)}>
              Ok
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent className={classes.content}>
            <DialogContentText id="alert-dialog-description" className={classes.text}>
              Do you want to save the changes you made to "{name} ?"
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.buttons}>
            <Button onClick={onApply} variant="contained" color="primary" autoFocus className={classes.button}>
              Save
            </Button>
            <Button onClick={onCancel} variant="contained" color="primary" autoFocus className={cn(classes.button)}>
              Cancel
            </Button>
          </DialogActions>
        </>
      )}
    </MUIDialog>
  );
};
